import { fontSizeBaseValue } from './theme-variables';

export const toRem = pixels => {
  return `${pixels / fontSizeBaseValue}rem`;
};

// Removes the layers of value from the props
// This returns a new changed props
export const cleanProps = props => {
  const objectMap = (obj, fn) =>
    Object.fromEntries(
      Object.entries(obj).map(([k, v], i) => [k, fn(v, k, i)])
    );

  return objectMap(props, value => {
    if (value === null) return null;
    if (typeof value === 'object' && 'value' in value) {
      if (value.value === null) return null;
      if (typeof value.value === 'object' && 'value' in value.value) {
        return value.value.value;
      }
      return value.value;
    }
    return value;
  });
};

// Return saved amout for products with discount
// Price constructed with product and variant const price = useDynamicPrice(product, variant) with Jetshop hook
export const getSavedAmount = price => {
  const currentPrice = price.price.incVat;
  const previousPrice = price.previousPrice.incVat;
  const save = previousPrice - currentPrice;
  return save;
};

export const getSavedAmountPercentage = price => {
  const currentPrice = price.price.incVat;
  const previousPrice = price.previousPrice.incVat;
  const save = 100 - Math.round((currentPrice / previousPrice) * 100);
  return save;
};
